import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-checkboxes', {
  mixins: [eventListenerMixin],

  properties: {
    showArchived: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.tabs = this.querySelector('tr-tabs');
    this.nativeField = this.querySelector('.result-field');
    this.searchInput = this.querySelector('.search-form input');

    this.listenTo(this.tabs, 'tr-tabs:activated', this.handleTabsActivated.bind(this));
    this.listenTo(this.searchInput, 'input', this.handleSearchInput.bind(this));
    this.listenTo(this, 'tr-checkbox-field:change', this.handleCheckboxChange.bind(this));
  },

  ready() {
    this.selectProjects();
  },

  disconnected() {
    this.stopListening();
  },

  replaceCheckboxFields(fields) {
    this.querySelector('.checkbox-fields-wrapper').innerHTML = fields;
    setTimeout(() => this.selectProjects(), 0);
  },

  selectProjects() {
    const selectedValue = this.getSelectedValue();

    [...this.querySelectorAll('.checkbox-fields tr-checkbox-field')].forEach((checkbox) => {
      // eslint-disable-next-line no-param-reassign
      checkbox.checked = selectedValue.indexOf(checkbox.getValue()) !== -1;
    });
  },

  getSelectedValue() {
    return [...this.nativeField.selectedOptions].map(option => option.value);
  },

  handleCheckboxChange(event) {
    const { checked, value } = event.detail;
    const nativeOption = [...this.nativeField.options].find(option => option.value === value);

    if (nativeOption) {
      nativeOption.selected = checked;
    } else {
      this.nativeField.appendChild(this.generateNativeOption(value));
    }
  },

  generateNativeOption(value) {
    const nativeOption = document.createElement('option');
    nativeOption.value = value;
    nativeOption.textContent = value;
    nativeOption.selected = true;
    return nativeOption;
  },

  handleTabsActivated() {
    this.searchInput.value = '';
  },

  selectAll() {
    const checkboxes = [...this.querySelectorAll('tr-checkbox-field')];
    if (checkboxes.filter(checkbox => !checkbox.checked).length === 0) return;

    const nativeOptions = [...this.nativeField.options];
    const newSelectedOptions = document.createDocumentFragment();

    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        // eslint-disable-next-line no-param-reassign
        checkbox.checked = true;

        const { value } = checkbox.nativeField;
        const nativeOption = nativeOptions.find(option => option.value === value);

        if (nativeOption) {
          nativeOption.selected = true;
        } else {
          newSelectedOptions.appendChild(this.generateNativeOption(value));
        }
      }
    });

    if (newSelectedOptions.children.length > 0) this.nativeField.appendChild(newSelectedOptions);
  },

  unselectAll() {
    const checkboxes = [...this.querySelectorAll('tr-checkbox-field')];
    if (checkboxes.filter(checkbox => checkbox.checked).length === 0) return;

    const unselectedValues = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        // eslint-disable-next-line no-param-reassign
        checkbox.checked = false;
        unselectedValues.push(checkbox.nativeField.value);
      }
    });

    [...this.nativeField.selectedOptions].forEach((option) => {
      // eslint-disable-next-line no-param-reassign
      if (unselectedValues.includes(option.value)) option.selected = false;
    });
  },

  handleSearchInput(event) {
    const url = this.tabs.querySelector('.mdc-tab--active').getAttribute('href');

    $.ajax({
      url,
      method: 'GET',
      data: {
        search: event.target.value,
      },
      dataType: 'script',
    });
  },
});
